<template>
  <v-container
    class="fill-height backgroundLogin"
    fluid
    id="login"
    :style="{
      '--bg-color': isCE ? '#e0e0e0' : '#fff !important',
      '--bg-color-mobile': isCE ? 'var(--corPrimaria)' : '#fff !important',
    }"
  >
    <v-row v-if="isSala">
      <login-selo>
        <template v-slot:formulario>
          <login-form></login-form>
        </template>
      </login-selo>
    </v-row>
    <v-row v-else-if="isCE">
      <LoginCE></LoginCE>
    </v-row>
    <v-row v-else>
      <GenericLogin></GenericLogin>
    </v-row>
  </v-container>
</template>

<script>
import GenericLogin from "./LoginComponents/Login";
import LoginSelo from "./LoginComponents/LoginSelo.vue";
import { mapGetters } from "vuex";
import LoginForm from "./LoginComponents/Form";
import LoginCE from "./LoginComponents/LoginCE";
import "./style.scss";

export default {
  computed: {
    ...mapGetters(["isSala", "isCE"]),
  },
  components: {
    GenericLogin,
    LoginSelo,
    LoginForm,
    LoginCE,
  },

  mounted() {
    setTimeout(() => this.$notification.removeAll(), 10);
  },
};
</script>

<style lang="scss" scoped>
#login {
  background-color: var(--bg-color);
}

@media screen and (max-width: 760px) {
  #login {
    background-color: var(--bg-color-mobile);
  }
}
</style>
